import { makeStyles, Theme } from "@material-ui/core";
import { VALUES } from "../../../data/constants/Colors";

export const marginStyles = makeStyles((theme: Theme) => ({
   margin: { height: VALUES.margin_normal },
}));
